import { Link } from 'react-router-dom'

export function SellerLandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-emerald-50">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-neutral-200">
        <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center">
              <span className="text-white font-black text-xl">N</span>
            </div>
            <span className="text-2xl font-black text-neutral-800">nolavi</span>
            <span className="ml-2 px-3 py-1 bg-emerald-100 text-emerald-700 text-xs font-semibold rounded-full">
              Sellers
            </span>
          </div>

          <div className="flex items-center gap-6">
            <a href="#features" className="text-sm font-medium text-neutral-600 hover:text-emerald-500 transition-colors">
              Features
            </a>
            <a href="#how-it-works" className="text-sm font-medium text-neutral-600 hover:text-emerald-500 transition-colors">
              How it Works
            </a>
            <a href="#benefits" className="text-sm font-medium text-neutral-600 hover:text-emerald-500 transition-colors">
              Benefits
            </a>
            <Link
              to="/login"
              className="text-sm font-medium text-neutral-600 hover:text-emerald-500 transition-colors"
            >
              Log In
            </Link>
            <Link
              to="/register"
              className="px-5 py-2.5 bg-emerald-500 text-white text-sm font-semibold rounded-lg hover:bg-emerald-600 transition-all duration-fast shadow-md hover:shadow-lg"
            >
              Registro
            </Link>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="pt-24 pb-12 sm:pb-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="inline-block px-4 py-2 bg-emerald-50 text-emerald-600 rounded-full text-sm font-semibold">
                Plataforma para Vendedores
              </div>

              <h1 className="text-5xl lg:text-6xl font-black text-neutral-900 leading-tight">
                Haz crecer tu negocio con Nolavi
              </h1>

              <p className="text-xl text-neutral-600 leading-relaxed">
                Únete a nuestro marketplace y alcanza miles de clientes. Gestiona tus productos,
                pedidos y ventas desde una sola plataforma profesional.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/register"
                  className="px-8 py-4 bg-emerald-500 text-white text-base font-semibold rounded-xl hover:bg-emerald-600 transition-all duration-fast shadow-lg hover:shadow-xl hover:scale-105 text-center"
                >
                  Comenzar a Vender
                </Link>
                <a
                  href="#how-it-works"
                  className="px-8 py-4 bg-white text-neutral-800 text-base font-semibold rounded-xl hover:bg-neutral-50 transition-all duration-fast border-2 border-neutral-200 hover:border-neutral-300 text-center"
                >
                  Ver Cómo Funciona
                </a>
              </div>

              <div className="flex items-center gap-8 pt-4">
                <div>
                  <div className="text-3xl font-bold text-neutral-900">500+</div>
                  <div className="text-sm text-neutral-600">Vendedores Activos</div>
                </div>
                <div className="w-px h-12 bg-neutral-200" />
                <div>
                  <div className="text-3xl font-bold text-neutral-900">50K+</div>
                  <div className="text-sm text-neutral-600">Productos Vendidos</div>
                </div>
                <div className="w-px h-12 bg-neutral-200" />
                <div>
                  <div className="text-3xl font-bold text-neutral-900">98%</div>
                  <div className="text-sm text-neutral-600">Satisfacción</div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="/images/hero/seller-hero-HXVO2CE4duA.jpg"
                  alt="Emprendedora con su negocio"
                  className="w-full h-full object-cover aspect-[4/3]"
                />
                <div className="absolute bottom-0 left-0 right-0 p-5 flex items-center justify-between bg-gradient-to-t from-black/70 to-transparent text-white">
                  <div className="flex items-center gap-3">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/90 text-emerald-600 font-black">
                      N
                    </div>
                    <div>
                      <p className="text-sm font-semibold">Nolavi Sellers</p>
                      <p className="text-xs text-white/80">Tu negocio, tu éxito</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-emerald-500/10 rounded-full blur-3xl" />
              <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-emerald-600/10 rounded-full blur-3xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-12 sm:py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-neutral-900 mb-4">
              ¿Por qué vender en Nolavi?
            </h2>
            <p className="text-xl text-neutral-600 max-w-2xl mx-auto">
              Todo lo que necesitas para gestionar y hacer crecer tu negocio
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-8 rounded-2xl bg-neutral-50 hover:bg-emerald-50 transition-all duration-normal border-2 border-neutral-200 hover:border-emerald-200 hover:shadow-lg">
              <div className="w-14 h-14 rounded-xl bg-emerald-500 flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-neutral-900 mb-3">Comisiones Bajas</h3>
              <p className="text-neutral-600 leading-relaxed">
                Tarifas competitivas que te permiten maximizar tus ganancias. Sin costos ocultos.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-neutral-50 hover:bg-emerald-50 transition-all duration-normal border-2 border-neutral-200 hover:border-emerald-200 hover:shadow-lg">
              <div className="w-14 h-14 rounded-xl bg-emerald-500 flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-neutral-900 mb-3">Panel de Control</h3>
              <p className="text-neutral-600 leading-relaxed">
                Gestiona tus productos, pedidos y ventas desde un dashboard intuitivo y completo.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-neutral-50 hover:bg-emerald-50 transition-all duration-normal border-2 border-neutral-200 hover:border-emerald-200 hover:shadow-lg">
              <div className="w-14 h-14 rounded-xl bg-emerald-500 flex items-center justify-center mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-neutral-900 mb-3">Miles de Clientes</h3>
              <p className="text-neutral-600 leading-relaxed">
                Accede a una audiencia amplia de compradores verificados buscando productos de calidad.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="py-12 sm:py-16 px-6 bg-gradient-to-br from-emerald-50 to-neutral-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-neutral-900 mb-4">
              Cómo Funciona
            </h2>
            <p className="text-xl text-neutral-600 max-w-2xl mx-auto">
              Comienza a vender en cuatro pasos sencillos
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 rounded-full bg-emerald-500 text-white text-3xl font-bold flex items-center justify-center mx-auto mb-6 shadow-lg">
                1
              </div>
              <h3 className="text-2xl font-bold text-neutral-900 mb-3">Regístrate</h3>
              <p className="text-neutral-600 leading-relaxed">
                Crea tu cuenta de vendedor en minutos
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 rounded-full bg-emerald-500 text-white text-3xl font-bold flex items-center justify-center mx-auto mb-6 shadow-lg">
                2
              </div>
              <h3 className="text-2xl font-bold text-neutral-900 mb-3">Verificación</h3>
              <p className="text-neutral-600 leading-relaxed">
                Completa el proceso KYC para garantizar confianza
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 rounded-full bg-emerald-500 text-white text-3xl font-bold flex items-center justify-center mx-auto mb-6 shadow-lg">
                3
              </div>
              <h3 className="text-2xl font-bold text-neutral-900 mb-3">Publica Productos</h3>
              <p className="text-neutral-600 leading-relaxed">
                Sube tus productos con fotos y descripciones
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 rounded-full bg-emerald-500 text-white text-3xl font-bold flex items-center justify-center mx-auto mb-6 shadow-lg">
                4
              </div>
              <h3 className="text-2xl font-bold text-neutral-900 mb-3">Vende y Gana</h3>
              <p className="text-neutral-600 leading-relaxed">
                Recibe pedidos y cobra tus ganancias
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="benefits" className="py-12 sm:py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-neutral-900 mb-4">
              Beneficios Exclusivos
            </h2>
            <p className="text-xl text-neutral-600 max-w-2xl mx-auto">
              Herramientas profesionales para vendedores serios
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="flex gap-4 p-6 rounded-xl hover:bg-neutral-50 transition-colors">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-lg bg-emerald-100 flex items-center justify-center">
                  <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
              <div>
                <h4 className="font-bold text-neutral-900 mb-2">Gestión de Inventario</h4>
                <p className="text-neutral-600">Control completo sobre tu catálogo de productos y stock.</p>
              </div>
            </div>

            <div className="flex gap-4 p-6 rounded-xl hover:bg-neutral-50 transition-colors">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-lg bg-emerald-100 flex items-center justify-center">
                  <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
              <div>
                <h4 className="font-bold text-neutral-900 mb-2">Reportes de Ventas</h4>
                <p className="text-neutral-600">Analítica detallada de tus ventas y rendimiento.</p>
              </div>
            </div>

            <div className="flex gap-4 p-6 rounded-xl hover:bg-neutral-50 transition-colors">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-lg bg-emerald-100 flex items-center justify-center">
                  <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
              <div>
                <h4 className="font-bold text-neutral-900 mb-2">Soporte Dedicado</h4>
                <p className="text-neutral-600">Equipo de soporte disponible para ayudarte cuando lo necesites.</p>
              </div>
            </div>

            <div className="flex gap-4 p-6 rounded-xl hover:bg-neutral-50 transition-colors">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-lg bg-emerald-100 flex items-center justify-center">
                  <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
              <div>
                <h4 className="font-bold text-neutral-900 mb-2">Pagos Seguros</h4>
                <p className="text-neutral-600">Recibe tus pagos de forma segura y puntual.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 px-6 bg-gradient-to-br from-emerald-500 to-emerald-600">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            ¿Listo para Comenzar?
          </h2>
          <p className="text-xl text-emerald-50 mb-8">
            Únete a cientos de vendedores exitosos en Nolavi
          </p>
          <Link
            to="/register"
            className="inline-block px-10 py-5 bg-white text-emerald-500 text-lg font-bold rounded-xl hover:bg-emerald-50 transition-all duration-fast shadow-2xl hover:scale-105"
          >
            Registrarme Ahora
          </Link>
          <div className="mt-6">
            <Link to="/login" className="text-emerald-50 hover:text-white font-medium transition-colors">
              ¿Ya tienes cuenta? Inicia sesión
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 px-6 bg-neutral-900 text-neutral-300">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center">
                  <span className="text-white font-black text-sm">N</span>
                </div>
                <span className="text-xl font-black text-white">nolavi</span>
              </div>
              <p className="text-sm text-neutral-400">
                Plataforma para vendedores exitosos
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-3">Recursos</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Guía de Vendedor</a></li>
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Centro de Ayuda</a></li>
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Mejores Prácticas</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-3">Soporte</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Contacto</a></li>
                <li><a href="#" className="hover:text-emerald-400 transition-colors">FAQ</a></li>
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Políticas</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-3">Legal</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Términos de Servicio</a></li>
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Privacidad</a></li>
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Comisiones</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-neutral-800 pt-8 text-center text-sm text-neutral-500">
            © 2025 Nolavi. Todos los derechos reservados.
          </div>
        </div>
      </footer>
    </div>
  )
}
